import React from 'react'
import styled from 'styled-components'
import ZoomIconOut from '../../../shared/ZoomIconOut'
import { pathOr } from 'ramda'

export const mapZoomTextOut = pathOr('', ['drupalSettings', 'widgets', 'mapZoom', 'textZoomOut'], window)


const ZoomButtonOut = ({ className, ...props }) => (
  <div className={className} {...props}>
    <React.Fragment>
      <ZoomIconOut />
      <span className='wording-agrandir-ab'>
        {mapZoomTextOut}
      </span>
    </React.Fragment>
  </div>
)

export default styled(ZoomButtonOut)`
        background: #FFFFFF;
        border: 5px solid #40e9c4;
        box-shadow: 0 6px 8px 0 rgba(0,0,0,0.25);
        width: 95px;
        height: 27px;
        display: inline-flex;
        border-radius: 55px;
        align-items: center;
        justify-content: space-around;
        cursor: pointer;
`
